import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonRow,
} from "@ionic/react";
import React from "react";

const Condiciones: React.FC = () => {
  let srcImg = process.env.PUBLIC_URL + "/imgs/ENEATEST_GRANDE.jpg";
  return (
    <IonPage>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow className="ion-text-center">
            <IonCol size="12">Términos y condiciones: en proceso</IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Condiciones;
